export default {
  name: 'user-groups',
  translationKey: 'user-groups-module',
  routePrefix: 'user-groups',
  routeNamePrefix: 'admin.user-groups',
  directRoutesAvailable: false,
}
